var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgSlackNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 23.725c0 1.5-1 2.5-2.5 2.5s-2.5-1-2.5-2.5 1-2.5 2.5-2.5H5v2.5zm1-.5c0-.902 1-2 2.5-2s2.5 1.098 2.5 2v7c0 .901-1 2-2.5 2s-2.5-1.099-2.5-2v-7z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14.225c.902 0 2 1 2 2.5s-1.098 2.5-2 2.5H2c-.902 0-2-1-2-2.5s1.098-2.5 2-2.5h7zm-.5-6c1.5 0 2.5 1 2.5 2.5v2.5H8.5c-1.5 0-2.5-1-2.5-2.5s1-2.5 2.5-2.5z",
    fill: "#36C5F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.225c1.5 0 2.5 1.098 2.5 2v7c0 .901-1 2-2.5 2s-2.5-1.099-2.5-2v-7c0-.902 1-2 2.5-2zm6 6c1.5 0 2.5 1 2.5 2.5s-1 2.5-2.5 2.5H19v-2.5c0-1.5 1-2.5 2.5-2.5z",
    fill: "#2EB67C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 27.225c1.5 0 2.5 1 2.5 2.5s-1 2.5-2.5 2.5-2.5-1-2.5-2.5v-2.5h2.5zm6.5-6c.902 0 2 1 2 2.5s-1.098 2.5-2 2.5h-7c-.902 0-2-1-2-2.5s1.098-2.5 2-2.5h7z",
    fill: "#ECB22D"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#F2FAFE",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9 1.789a7.111 7.111 0 017.107 6.871l.004.24a7.111 7.111 0 01-6.871 7.107l-.24.004a7.111 7.111 0 010-14.222zm-.19 5.528h-.949a.318.318 0 00-.317.318v.102c0 .13.079.247.2.295l.088.044a.664.664 0 01.306.742l-.885 3.338a.955.955 0 00.928 1.196h.95a.318.318 0 00.317-.318v-.102a.318.318 0 00-.2-.295l-.089-.044a.664.664 0 01-.305-.743l.884-3.338a.955.955 0 00-.928-1.195zm.599-2.86l-.122.001-.112-.002c-.52.02-.955.425-1 .955l.016.112c.098.511.565.879 1.096.841l.113.002c.52-.019.955-.424.999-.955l-.015-.112a1.042 1.042 0 00-1.097-.84z",
    fill: "#148CFC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackNotification);
export default ForwardRef;